import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Modal, WindowLoader, formatDate } from 'medere-ui-framework';
import { useIntl } from 'react-intl';
import './PatientAgendaWithPatientView.scss';
import CollapsibleCard from '../../../../components/CollapsibleCard';
import { Icon } from '@iconify/react';
import GeneralRecipeViewCard, { addLineBreaksAndStippling } from '../../Components/GeneralRecipeViewCard';
import { ERecipeViews, ESteps, EAgendaViews } from '../../RecipeEnums';
import { DigitalRpForHistoryDTO, HealthPatientCoverage, PatientRecordDTO, Professional } from '../../../../interface/interface';
import { loadDigitalRpHistory } from '../../../../services/digitalRPservice';

const PatientAgendaWithPatientView = ({ setActiveView, setSubActiveView, setPrevActiveView, setPrevSubActiveView, professional, selectedPatient, onBack, onEditPatient }:{ setActiveView: (av: number|undefined) => void, setSubActiveView: (sav: number|undefined) => void, setPrevActiveView: (pav: number|undefined) => void, setPrevSubActiveView: (psav: number|undefined) => void, professional:Professional, selectedPatient:PatientRecordDTO|null, onBack: () => void, onEditPatient: (patient: PatientRecordDTO|null) => void }) => {
    const intl = useIntl();

    const [openRecipeHistoryModal, setOpenRecipeHistoryModal] = useState(false)

    const [completedRecipes, setCompletedRecipes] = useState<DigitalRpForHistoryDTO[]|null>();

    const [, setisMobile] = useState(window.innerWidth < 700)

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };

        const loadHistoryRecipesForPatient = async () => {
            setLoading(true)
            const recipesFromHistory:DigitalRpForHistoryDTO[] = await loadDigitalRpHistory(professional.professionaid, selectedPatient?.firstname+" "+selectedPatient?.lastname)
                                                                    .then((res) => {
                                                                        return res
                                                                    })
                                                                    .catch((error) => {
                                                                        console.error('Error: ', error); 
                                                                        return [];
                                                                    });
            setCompletedRecipes(recipesFromHistory);
            setLoading(false)
        };
        
        loadHistoryRecipesForPatient();

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSearchRecipeHistoryOfPatient = () => {
        setOpenRecipeHistoryModal(true)
    }

    const handleNewRecipe = () => {
        setPrevSubActiveView(EAgendaViews.PATIENTAGENDAWITHPATIENTVIEW)
        setPrevActiveView(ERecipeViews.PATIENTAGENDA)

        setSubActiveView(ESteps.MEDICATIONSTEP),
        setActiveView(ERecipeViews.NEWRECIPE)
    }

    return (
        <div className="patient-agenda-with-patient-view" style={{ padding: '15px' }}>
            <div style={{marginLeft: '-15px'}}>
                <Button className='btnCancel' label={'◄ '+intl.formatMessage({ id: "Back" })} onClick={() => onBack()} />
            </div>
            
            <h1 style={{ fontWeight: 600 }}>Agenda de pacientes</h1>
            
            <div style={{marginBottom:'20px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <div>
                    <h2><strong>{selectedPatient?.firstname+" "+selectedPatient?.lastname}</strong></h2>
                    <p>DNI: {selectedPatient?.document}</p>
                </div>
                <button 
                    onClick={() => {
                        if(selectedPatient) onEditPatient(selectedPatient)
                    }}>
                    <Icon icon='bi:pencil-square' style={{ color:'#01717C', fontSize: '34px', padding: '8px', backgroundColor: '#DBDFE5', borderRadius: '100%' }} />
                </button>
            </div>  
                
            <div style={{boxShadow: '0 4px 4px rgba(0,0,0,0.15)'}} className="collapsible-card">
                <div className='content-header'>
                    <div className="header">
                        <div style={{color:'#B27668'}} className="title">COBERTURA MEDICA</div>
                    </div>
                </div>
                <div className="content">
                    {selectedPatient && selectedPatient.insurances && selectedPatient.insurances.length > 1 ? (
                            selectedPatient.insurances.map((insurance:HealthPatientCoverage, index) => (
                                <div>
                                    <CollapsibleCard
                                        key={index}
                                        title={<label style={{color:'#1E1E1E'}}>{insurance.healthentityplan.healthentity.commercialname}</label>}
                                        noShadow
                                    >
                                        <div>
                                            <p>Obra Social y Plan</p>
                                            <p><strong>{insurance.healthentityplan.healthentity.commercialname+" - "+insurance.healthentityplan.name}</strong></p>
                                            <p>Afiliado</p>
                                            <p><strong>{insurance.benefitnumber}</strong></p>
                                            <p style={{fontFamily:'sans-serif', fontStyle:'italic', marginTop:'10px'}}>{insurance.voluntary ? "Cobertura Voluntaria":"Cobertura Obligatoria"}</p>
                                        </div>
                                    </CollapsibleCard>
                                    {index !== (selectedPatient.insurances?.length??0)-1 && <hr />}
                                </div>
                            ))
                        ) : (
                            <div style={{paddingLeft:'15px'}}>
                                <p>Obra Social y Plan</p>
                                <p style={{marginBottom:'12px'}}><strong>{selectedPatient?.insurances && selectedPatient.insurances[0].healthentityplan.healthentity.commercialname+" - "+selectedPatient.insurances[0].healthentityplan.name}</strong></p>
                                <p>Afiliado</p>
                                <p><strong>{selectedPatient?.insurances && selectedPatient.insurances[0].benefitnumber}</strong></p>
                                <p style={{fontFamily:'sans-serif', fontStyle:'italic', marginTop:'10px'}}>{selectedPatient?.insurances && selectedPatient.insurances[0].voluntary ? "Cobertura Voluntaria":"Cobertura Obligatoria"}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            <div style={{ display:'flex', flexDirection:'column' }}>
                <Button
                    className='btnRpContinue'
                    icon={<Icon icon='vaadin:pills' style={{ display: 'inline', marginRight: '5px', paddingBottom: '5px', fontSize: '25px', color: 'white' }} />}
                    label={"NUEVA RECETA"}
                    onClick={handleNewRecipe}
                    style={{ display: 'block', boxShadow: '0px 3px 12px -1px rgba(28, 52, 84, 0.26)', marginTop: '8px', backgroundColor: '#3CB8BA', border: 'none', height:'36px', marginBottom: '15px'}}
                />
            </div>

            <GeneralRecipeViewCard
                title={<label><strong>Historial</strong> de recetas</label>}
                detail={<label>Existen <strong>{(completedRecipes?.length ? completedRecipes?.length : 0)+" items"}</strong> en el historial del paciente</label>}
                detailFontSize='13px'
                detailColor='#404040'
                detail2={''}
                onClick={() => {
                    handleSearchRecipeHistoryOfPatient()
                }}
                backgroundColor="#FFFFFF"
                titleColor="#009688"
                boxShadow='0 2px 5px rgba(0,0,0,0.2)'
            />

            <CollapsibleCard
                title="DATOS PERSONALES"
            >
                <div>
                    <p>Fecha de Nacimiento</p>
                    <p style={{marginBottom:'5px'}}><strong>01/01/2016</strong></p>
                    <p>Sexo</p>
                    <p style={{marginBottom:'5px'}}><strong>Femenino</strong></p>
                    <p>Mail</p>
                    <p style={{marginBottom:'5px'}}><strong>{selectedPatient?.email}</strong></p>
                    <p>Cel</p>
                    <p><strong>{selectedPatient?.mobilephone}</strong></p>
                </div>
            </CollapsibleCard>

            <div style={{boxShadow: '0 4px 4px rgba(0,0,0,0.15)'}} className="collapsible-card">
                <div className='content-header'>
                    <div className="header">
                        <div style={{color:'#B27668'}} className="title">OBSERVACIONES</div>
                    </div>
                </div>
                <div className="content">
                    {!selectedPatient?.observations && (
                        <div style={{ fontFamily:'sans-serif', fontStyle: 'italic', fontSize:'14px', color: '#838383' }}>No hay datos ingresados</div>
                    )}
                    {selectedPatient?.observations && (
                        <div>{selectedPatient?.observations}</div>
                    )}
                </div>
            </div>

            <Modal
                visible={openRecipeHistoryModal}
                setVisible={setOpenRecipeHistoryModal}
                header={<h1 style={{marginTop:'8px', fontWeight:600, fontSize:'20px'}}>Historial de recetas</h1>}
                className='h-full'
            >
                <div className="recipe-history-tab">
                    <div style={{marginBottom:'1.5rem'}}>
                        <h2><strong>{selectedPatient?.firstname+" "+selectedPatient?.lastname}</strong></h2>
                        <p>DNI: {selectedPatient?.document}</p>
                    </div>
                    {completedRecipes?.map((recipe, index) => (
                        <GeneralRecipeViewCard
                            key={index}
                            style={{cursor: 'auto'}}
                            title={""}
                            detail={addLineBreaksAndStippling(recipe.medicineprescribeddescription, true)}
                            detail2={formatDate(recipe.dateprescribed)}
                            onClick={()=>{}}
                            backgroundColor='#FFFFFF'
                            titleColor='#009688'
                            border='1px solid #A9A9A9'
                        />
                    ))}
                </div>
            </Modal>

            <WindowLoader showLoader={loading} className='whiteSpinner'/>
        </div>
    );
};

export default PatientAgendaWithPatientView;
